import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  is_loader: false,
  is_create_modal:false,
  is_add_technician:false,
  is_technican_assign_modal:false,
  is_reschedule_modal:false,
  image_modal:"",
  edit_Technician:"",
  slotPage:false,
  pickupModal:false,
  dropModal:false

}

export const pageAction = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setLoader: (state, action) => {
      state.is_loader = action.payload
    },
    setCreatemodal:(state,action)=>{
      state.is_create_modal = action.payload
    },
    setTechncian:(state,action)=>{
      state.is_add_technician = action.payload
    },
    setAssignTechnician:(state,action)=>{
      state.is_technican_assign_modal = action.payload
    },
    setRescheduleModal:(state,action)=>{
      state.is_reschedule_modal = action.payload
    },
    setImageModal:(state,action)=>{
      state.image_modal = action.payload
    },
    setEditTechnician:(state,action)=>{
      state.edit_Technician = action.payload
    },
    setSlotPage:(state,action)=>{
      state.slotPage = !state.slotPage
    },
    setPickupModal:(state,action)=>{
      state.pickupModal = !state.pickupModal
    },
    setDropModal:(state,action)=>{
      state.dropModal = !state.dropModal
    }
  },
})

export const { setLoader,setCreatemodal,setTechncian,setAssignTechnician,setRescheduleModal,setImageModal,setEditTechnician,setSlotPage,setPickupModal,setDropModal } = pageAction.actions

export default pageAction.reducer